<template lang="pug">
  vm-prompt(
    @vm-cancel="close"
    @vm-accept="saveAndClose"
    @vm-close="close"
    @vm-action="deleteRecordConfirm(form)"
    :vm-action="form.id && !isAdd"
    vm-action-text="Eliminar"
    vm-accept-text="Guardar"
    vm-cancel-text="Cancelar"
    :vm-is-valid="!$v.form.$invalid"
    :vm-active="isModalVisible"
    :vm-title="getTitle"
  )
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center" vm-align="center" vm-w=12)
        b-form-group
          vm-input(
            autofocus
            placeholder="Nombre del error"
            :danger="$v.form.name.$invalid && $v.form.name.$model !== undefined && $v.form.name.$model !== ''"
            danger-text="El nombre es obligatorio"
            v-model="form.name"
            label="Nombre"
          )
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('ErrorCatalogs')

export default {
  name: 'ModalErrorCatalog',
  mixins: [ModalMixin1],
  validations () {
    return {
      form: {
        name: { required }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible']),
    getTitle () {
      return this.isAdd ? 'Agregar error' : 'Editar error'
    }
  },
  methods: {
    ...mapActions(['addRecord', 'editRecord', 'deleteRecord', 'setModalVisible']),
    async saveAndClose () {
      if (this.isAdd) {
        await this.addRecord(this.form)
      } else {
        await this.editRecord(this.form)
      }
      this.close()
    }
  }
}
</script>
